<template>
  <v-dialog v-model="dialog" max-width="75%">
    <v-card>
      <v-card-title style="background-color: #2b3990">
        <span class="headline white--text">{{ titleForm }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="StepDescription"
                  label="Hab Step"
                  :disabled="true"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  v-model="newAssistance"
                  label="Assistance"
                  :items="assistance"
                  :rules="requiredRules"
                ></v-select>
              </v-col>
              <v-col class="d-flex" cols="6" sm="6">
                <v-textarea v-model="newNotes" label="Notes"></v-textarea>
              </v-col>
              <v-col class="d-flex" cols="6" sm="6" style="position:relative;">
                <v-text-field
                  class="update-icon"
                  v-model="newSignature"
                  label="Signature"
                  append-icon="mdi-pencil-box-outline"
                  @click:append="onUpdateSignature()"
                  v-if="canUpdate"
                ></v-text-field>
                <v-text-field
                  class="update-icon"
                  v-model="newSignature"
                  label="Signature"
                  readonly
                  disabled
                  v-if="!canUpdate"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn class="blue darken-2 white--text" text @click="addADL()" v-if="newService">Save</v-btn
                                > -->
        <v-btn color="blue darken-1" text @click="onUpdateItem" v-if="editADL"
          >Update</v-btn
        >
        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import moment from "moment";

export default {
  components: {

  },
  props: {
    itemData: {
      type: Object,
    },
    updatedSignature: {
      type: String,
    },
  },
  data() {
    return {
      titleForm: "Update HAB Plan Item",
      newDate: "",
      StepDescription: "",
      newAssistance: "",
      newNotes: "",
      newSignature: "",
      assistance: ["Prompts Needed", "Participated", "Refused", "Home Visit", "Absent", "Yes", "No"],
      editADL: false,
      requiredRules: [],
      habSignedID: null,
      clientID: this.$route.params.clientID,
      canUpdate: false,
      roles: [
        "Administration",
        "Program Coordinator",
        "Client Services Manager",
        "Compliance Manager",
        "Human Resources",
        "Medical Manager",
      ],
      servicePlan: [],
      hasAttachment: false
    };
  },

  computed: {
    dialog: {
      get() {
        return this.$store.state.services.dialog;
      },
      set(val) {
        this.$store.commit("services/SET_DIALOG", val);
      },
    },
  },
  
  watch:{
    servicePlan(val){
      this.hasAttachment = val.Attachments.length != 0
    }
  },

  methods: {
    onViewItem(item) {
      this.adlItemData = item;
      this.titleForm = "Viewing HAB Plan";
      this.dialog = true;
      this.editADL = true;
      this.newADL = false;
      this.StepDescription = item.StepDescription;
      this.newDate = item.Date;
      this.newAssistance = item.Assistance;
      this.newNotes = item.Notes;
      this.newSignature = item.Signature;
      this.newClientID = item.ClientID;
      this.habSignedID = item._id;

      this.canUpdateSignature();
    },

    canUpdateSignature() {
      if (this.adlItemData.Signature === "") return (this.canUpdate = true);

      if (this.roles.includes(this.$store.state.users.user.Role)) {
        return (this.canUpdate = true);
      }
      return (this.canUpdate = false);
    },
    onUpdateItem() {
      var data = {
        Assistance: this.newAssistance,
        Notes: this.newNotes,
        Signature: this.newSignature,
      };
      this.$emit("updateHABSigned", data, this.habSignedID);
    },
    onUpdateSignature() {
      this.$emit("updateSignature");
      this.$nextTick(() => {
        this.newSignature = this.updatedSignature;
      });
    },
    close() {
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.update-icon >>> .mdi-pencil-box-outline {
  color: #5a99f6;
}
</style>
